import React, { useContext } from 'react';
import { Button, Card, CardBody, CardFooter, Col, Form, Input, Label, Row, Spinner } from 'reactstrap';
import { GlobalStore } from '../../../StateStores';
import { toast } from 'react-toastify';
import { requestControlNumber } from '../../../Actions/InvoiceActs';

const ControlNumberManager = ({transaction,toggleModal})=>{

    const {InvoiceDispatch,InvoiceState:{
        postControlNumberState:{error,loading,data},
    }} = useContext(GlobalStore);

    

    const sendControlNumber = async (e)=>{
        e.preventDefault()
        try {
            const response = await requestControlNumber(transaction)(InvoiceDispatch);
            if(response.status){
                toast.success(response.message)
                toggleModal()
            }
        } catch (error) {
            toast.error(error.message)
        }
    }

    return(
        <React.Fragment>
            <Card className='shadow-sm'>
                <Form onSubmit={sendControlNumber}>
                    <CardBody>
                        <Row>
                            <Col>
                                <Label>Transaction To:</Label>
                                <Input readOnly className='bg-light' type='text' value={transaction?.registration_number}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label>Transaction No:</Label>
                                <Input readOnly className='bg-light' type='text' value={transaction?.trans_code}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label>Transaction To:</Label>
                                <Input readOnly className='bg-light' type='text' value={transaction?.trans_amount}/>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <div className='d-flex'>
                            <Button>
                                {loading && <Spinner size="sm"/>}
                                <span className='ms-1'>Generate Controll number</span>
                            </Button>
                        </div>
                    </CardFooter>
                </Form>
            </Card>
        </React.Fragment>
    )
}

export default ControlNumberManager